var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeating = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M22.488 21.156V10.312a2.28 2.28 0 0 0-2.282-2.282h-.456a2.28 2.28 0 0 0-2.283 2.282v10.844a5.477 5.477 0 1 0 7.986 4.867 5.47 5.47 0 0 0-2.965-4.867Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M19.85 28.133a2.055 2.055 0 1 0-.001-4.109 2.055 2.055 0 0 0 0 4.11ZM19.977 23.893V10.55"
}))));
export default SvgHeating;